export default __webpack_public_path__ + "static/media/intercom.b83683b7.jpg";